module.exports = __webpack_public_path__ + "img/wifi-1.c64f1ba0.svg";